import makeStyles from '@material-ui/core/styles/makeStyles'

export const useStylesBottomBadge = makeStyles(({
	badge: {
		top: '80%',
		minWidth: 16,
		height: 16,
	},
}), {name: 'BottomBadge'});